;(function () {
  // 通过页面+区域 class 匹配，不依赖 section id
  var SECTION_SELECTOR = '.holiday-allowance-2026 .winter-sale-tab-product'
  var SELECTORS = [
    '.card-product-4__title.card-product__title',
    '.card-product-4__subtitle.card-product__subtitle',
    '.card-product-4__klanra.card-product__klanra',
  ]
  var MOBILE_MAX = 850

  function getSections() {
    return document.querySelectorAll(SECTION_SELECTOR)
  }
  function isMobile() {
    return window.innerWidth <= MOBILE_MAX
  }

  // 复位之前写入的内联高度
  function resetHeights(section) {
    SELECTORS.forEach(function (sel) {
      section.querySelectorAll(sel).forEach(function (el) {
        el.style.height = ''
        el.style.minHeight = ''
      })
    })
  }

  // 让未激活的 tab 产品容器在测量期间可见（离屏，不动 active 容器以避免抑抑）
  function withTabsVisible(section, fn) {
    var containers = section.querySelectorAll(
      '.bfcm-tab-products__products-container'
    )
    var saved = []
    var slideSaved = []
    var refWidth = section.clientWidth

    // 先找 active 容器里一个真实可见的 .swiper-slide 宽度作为参考。
    // 非 active 容器的 swiper 是在 display:none 时初始化的，slide 宽度可能是 0，
    // 测量时如果不强制覆盖，title 会被压成超窄柱状导致行数虚高。
    var activeContainer = section.querySelector(
      '.bfcm-tab-products__products-container.active'
    )
    var refSlideWidth = 0
    if (activeContainer) {
      var refSlide = activeContainer.querySelector('.swiper-slide')
      if (refSlide) refSlideWidth = refSlide.getBoundingClientRect().width
    }

    containers.forEach(function (c) {
      if (c.classList.contains('active')) return
      saved.push({ el: c, cssText: c.style.cssText })
      // 注意：不要用 visibility:hidden —— 它会继承到所有后代，
      // 让 getComputedStyle(child).visibility === 'hidden'，触发我们自己的过滤被全部 skip。
      // 仅靠 position:absolute + left:-99999px 把它移到屏外即可。
      c.style.setProperty('display', 'block', 'important')
      c.style.setProperty('position', 'absolute', 'important')
      c.style.setProperty('left', '-99999px', 'important')
      c.style.setProperty('top', '0', 'important')
      c.style.setProperty('width', refWidth + 'px', 'important')
      c.style.setProperty('pointer-events', 'none', 'important')
      // opacity:0 仅是视觉冗余保险，不影响 computedStyle.visibility
      c.style.setProperty('opacity', '0', 'important')

      // 修正 swiper-slide 宽度：Swiper 在 display:none 容器里初始化得到的 width=0
      // 会让卡片被极窄压缩，title 行数虚高（5 行 → 70px）。
      if (refSlideWidth > 0) {
        c.querySelectorAll('.swiper-slide').forEach(function (s) {
          slideSaved.push({ el: s, cssText: s.style.cssText })
          s.style.setProperty('width', refSlideWidth + 'px', 'important')
        })
      }
    })
    try {
      fn()
    } finally {
      slideSaved.forEach(function (s) {
        s.el.style.cssText = s.cssText
      })
      saved.forEach(function (s) {
        s.el.style.cssText = s.cssText
      })
    }
  }

  // PC: 跨 tab 全局最大值 + height
  function equalizeDesktop(section) {
    withTabsVisible(section, function () {
      SELECTORS.forEach(function (sel) {
        var els = section.querySelectorAll(sel)
        if (!els.length) return
        var max = 0
        els.forEach(function (el) {
          var h = el.getBoundingClientRect().height
          if (h > max) max = h
        })
        if (!max) return
        els.forEach(function (el) {
          el.style.height = max + 'px'
        })
      })
    })
  }

  // 移动端: 跨所有 tab 取全局最大值，并写入所有 tab 对应元素的 min-height
  function equalizeMobile(section) {
    // 让所有 tab 容器可测量（包含非 active 的隐藏 tab）
    withTabsVisible(section, function () {
      SELECTORS.forEach(function (sel) {
        var els = section.querySelectorAll(sel)
        if (!els.length) return
        var max = 0
        els.forEach(function (el) {
          var h = el.getBoundingClientRect().height
          if (h > max) max = h
        })
        if (!max) return
        els.forEach(function (el) {
          el.style.minHeight = max + 'px'
        })
      })
    })
  }

  function equalizeOne(section) {
    if (!section) return
    // PC 端只复位，不应用
    if (!isMobile()) {
      resetHeights(section)
      return
    }
    // 移动端：reset + measure + apply 全部在同一个同步任务中完成，
    // 中间不让浏览器有机会绘制 "被清除 min-height" 的中间状态。
    withTabsVisible(section, function () {
      resetHeights(section)
      SELECTORS.forEach(function (sel) {
        var els = section.querySelectorAll(sel)
        if (!els.length) return
        // 1) 测量每个元素的"纯内容高度"= boundingRect 高度 - 上下 padding - 上下 border
        //    并顺手记下每个元素自身的 padding+border 总和，回写时要加回去（border-box 下 min-height 含 padding+border）
        //    跳过被隐藏的元素（祖先 display:none / 自身被折叠等），避免脏数据撑大 max
        var measures = []
        var maxContent = 0
        els.forEach(function (el) {
          // offsetParent 为 null = 有祖先 display:none（不含 position:fixed）
          if (el.offsetParent === null) return
          var rect = el.getBoundingClientRect()
          if (rect.height <= 0) return
          // 跳过 "更多产品" 的 PC 端 swiper（移动端通常 display:none，但有时只是视觉隐藏）
          if (el.closest('.bfcm-tab-products-tabs__swiper-products')) return
          // 跳过 Shopify 编辑器里 disabled 的 block —— 这些 block 会带 [hidden] 属性
          // （注意：生产环境下 disabled block 根本不会被渲染到 DOM，这一行只对编辑器/预览模式生效）
          if (el.closest('[hidden]')) return
          var cs = window.getComputedStyle(el)
          // 二次保险
          if (cs.display === 'none' || cs.visibility === 'hidden') return
          var pt = parseFloat(cs.paddingTop) || 0
          var pb = parseFloat(cs.paddingBottom) || 0
          var bt = parseFloat(cs.borderTopWidth) || 0
          var bb = parseFloat(cs.borderBottomWidth) || 0
          var extra = pt + pb + bt + bb
          // border-box: min-height 含 padding+border，需要把 extra 加回去
          // content-box: min-height 只算内容区，extra 设为 0，不要加回去
          var isBorderBox = cs.boxSizing === 'border-box'
          var content = rect.height - extra
          if (content < 0) content = 0
          if (content > maxContent) maxContent = content
          measures.push({ el: el, extra: isBorderBox ? extra : 0 })
        })
        if (!maxContent || !measures.length) return
        // 2) 按各元素自身 padding/border 把"纯内容最大值"写回为有效 min-height
        //    注意：只回写参与过测量的元素；被跳过的隐藏元素不动它们
        measures.forEach(function (m) {
          m.el.style.minHeight = maxContent + m.extra + 'px'
        })
      })
    })
  }

  function equalize() {
    getSections().forEach(equalizeOne)
  }

  var rafId
  function schedule() {
    if (rafId) cancelAnimationFrame(rafId)
    rafId = requestAnimationFrame(function () {
      requestAnimationFrame(equalize)
    })
  }

  var timer
  function debounced() {
    clearTimeout(timer)
    timer = setTimeout(schedule, 150)
  }

  // 基础触发时机
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule)
  } else {
    schedule()
  }
  window.addEventListener('load', schedule)
  window.addEventListener('resize', debounced)
  window.addEventListener('orientationchange', debounced)

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule).catch(function () {})
  }

  // 注意：不在 tab 点击时重算。min-height 已经全局写入所有 tab 的元素，
  // 切 tab 时新容器里的卡片自带 min-height，不需要任何补偿。

  // 区域内图片加载完会影响高度
  ;(function bindImages() {
    var sections = getSections()
    if (!sections.length) {
      setTimeout(bindImages, 200)
      return
    }
    sections.forEach(function (section) {
      section.querySelectorAll('img').forEach(function (img) {
        if (img.complete) return
        img.addEventListener('load', debounced, { once: true })
        img.addEventListener('error', debounced, { once: true })
      })
    })
  })()

  // 接入 Swiper：只听 resize / imagesReady（这些会真正改变高度），
  // 不听 slideChange、update——它们在切 tab / swiper.update() 时频繁触发，是抑抑根源。
  function hookSwipers() {
    var swipers = window.swipers
    if (!swipers) return false
    var hooked = false
    Object.keys(swipers).forEach(function (key) {
      var sw = swipers[key]
      if (!sw || sw.__equalHooked) return
      sw.__equalHooked = true
      hooked = true
      try {
        sw.on('resize', debounced)
        sw.on('imagesReady', debounced)
      } catch (_) {}
    })
    return hooked
  }
  // 轮询绑定（swiper 初始化在 $(document).ready 内，可能晚于本脚本）
  var tries = 0
  var swiperTimer = setInterval(function () {
    tries++
    if (hookSwipers() || tries > 40) clearInterval(swiperTimer)
  }, 150)
})()
